import * as serviceContext from './serviceContext';

var options = {};
var headers = new Headers();

headers.append('Content-Type', 'application/json');
options.headers = headers;


export async function getRebateBonusList() {
    try {
        const response = await serviceContext.get("online/RebateBonus", null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};


export async function updateRebateBonus(data) {
    try {
        const response = await serviceContext.put("online/RebateBonus", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};